import React from 'react';
import { withBlockExtensions } from '@plone/volto/helpers';
import {
  DestaquesCarrosselSection,
  DESTAQUES_CARROSSEL_TITLE,
} from 'volto-ministerio-publico-federal/components/View/CapaView/DestaquesCarrosselSection';
import {
  destaquesCarrosselHasContent,
  type DestaquesCarrosselData,
} from 'volto-ministerio-publico-federal/components/View/CapaView/helpers';

interface MpfDestaquesCarrosselBlockViewProps {
  data: DestaquesCarrosselData;
  /** Presente só no editor: índice do slide em `data.items`. */
  onEditItem?: (index: number) => void;
}

const EMPTY_TEXT =
  'Sem destaques cadastrados. Adicione ao menos um para a faixa aparecer na capa.';

/** Bloco "Destaques — carrossel (capa)". */
const MpfDestaquesCarrosselBlockView = ({
  data,
  onEditItem,
}: MpfDestaquesCarrosselBlockViewProps) => {
  // Sem itens o bloco ficaria invisível e o editor não conseguiria
  // selecioná-lo — daí o cartão tracejado com o texto gravado no bloco.
  if (!destaquesCarrosselHasContent(data)) {
    return (
      <section className="rounded-md border border-dashed border-gray-300 p-4 dark:border-night-850">
        <h2 className="text-lg font-semibold text-on-surface dark:text-night-100">
          {data?.title || DESTAQUES_CARROSSEL_TITLE}
        </h2>
        <p className="mt-1 text-sm text-gray-500 dark:text-night-400">
          {data?.placeholder || EMPTY_TEXT}
        </p>
      </section>
    );
  }

  /* `isEditMode={!!onEditItem}`, e não cravado em `true`: só o `Edit.tsx` passa
     `onEditItem`. Cravado, a página PUBLICADA herdava o comportamento de
     edição — slots vazios apareciam e os cards deixavam de ser links (ver os
     usos de `isEditMode` em `View/CapaView`). */
  return (
    <DestaquesCarrosselSection
      data={data}
      isEditMode={!!onEditItem}
      onEditItem={onEditItem}
    />
  );
};

export default withBlockExtensions(MpfDestaquesCarrosselBlockView);
